/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';

export interface UnassignAdminProfile$Request {
    adminId: number;
    reason?: string;
}

export interface UnassignAdminProfile$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const unassignAdminProfileRequest = createAction<PayloadData<void, UnassignAdminProfile$Request>>('UNASSIGN_ADMIN_PROFILE__UNASSIGN_ADMIN_PROFILE__REQUEST');
export const unassignAdminProfileSuccess = createAction<PayloadData<void, UnassignAdminProfile$Request>>('UNASSIGN_ADMIN_PROFILE__UNASSIGN_ADMIN_PROFILE__SUCCESS');
export const unassignAdminProfileFailure = createAction<PayloadData<Error, UnassignAdminProfile$Request, true>>('UNASSIGN_ADMIN_PROFILE__UNASSIGN_ADMIN_PROFILE__FAILURE');

export const unassignAdminProfileActions = [
    unassignAdminProfileRequest,
    unassignAdminProfileSuccess,
    unassignAdminProfileFailure
] as const;

/**
 * @param {number} meta.adminId
 * @param {string} [meta.reason] Optional audit reason for this update. Blank values use the existing operation-specific reason.
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const unassignAdminProfile = (meta: UnassignAdminProfile$Request, config?: UnassignAdminProfile$Config) => {
    const TRANSPORT_GET_PARAMS = {
        reason: meta.reason,
    };
    return {
        CALL_API: {
            types: unassignAdminProfileActions,
            method: ApiMethods.DELETE,
            endpoint: `/web-api/admins/${meta.adminId}/profiles`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

